import React, { useEffect, useMemo, useState } from 'react';
import { unionFlag, getSessonStorage } from '@/utils';
import { withRouter } from 'umi';
import { connect } from 'dva';
import styles from './index.less';
import { TLang } from '@/utils/lang';

const dfDiscount = (props: any) => {
  const unionCode = unionFlag() || getSessonStorage('dffl_union');

  return (
    <span className={styles.discount} style={props?.style}>{TLang('折', 'home', false, false, null)}</span>
  );
};
const mapStateToProps = ({ initData }) => ({ unionConfig: initData.unionConfig });
export default withRouter(connect(mapStateToProps)(dfDiscount));
